/*==================================================
WG SOCIAL + NEWSLETTER
==================================================*/

document.addEventListener("DOMContentLoaded", () => {

const form = document.querySelector(".wg-newsletter-form");

if(form){

const input = form.querySelector("input");

const button = form.querySelector("button");

form.addEventListener("submit",(e)=>{

e.preventDefault();

const email = input.value.trim();

const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

if(!regex.test(email)){

input.focus();

input.classList.add("is-error");

return;

}

input.classList.remove("is-error");

button.disabled = true;

button.classList.add("is-success");

button.innerHTML="Subscribed ✓";

setTimeout(()=>{

button.disabled=false;

button.classList.remove("is-success");

button.innerHTML="Subscribe";

form.reset();

},2500);

});

}

/*==========================================
INSTAGRAM FEED ANIMATION
==========================================*/

const feed=document.querySelector(".wg-instagram-wrapper");

if(feed){

const observer=new IntersectionObserver((entries)=>{

entries.forEach(entry=>{

if(entry.isIntersecting){

feed.classList.add("is-visible");

}

});

},{
threshold:.2
});

observer.observe(feed);

}

});